import { render, staticRenderFns } from "./attachedDocs.vue?vue&type=template&id=f1f45d12&"
import script from "./attachedDocs.vue?vue&type=script&lang=js&"
export * from "./attachedDocs.vue?vue&type=script&lang=js&"
import style0 from "./attachedDocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports